import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Checkbox, FormControlLabel, Grid, Paper, TextField, Typography } from '@mui/material';

import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import SaveButton from '../ui/SaveButton';
//import PhoneNumberFormat from '../ui/PhoneNumberFormat';
//import Address from '../ui/Address'
import EmailDialog from '../ui/EmailDialog';
import UserEmailForm from './UserEmailForm';
import AppBindStyles from '../../AppBindStyles';

import BindCardUnattachedFetch from '../customer/BindCardUnattachedFetch';


const abEnvironment = new AbEnvironment();
const UserCreateQuery = graphql`
query UserCreateQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountType
    accountName
    useBudgets
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      marginTop: 10,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginTop: -16
    },
    textFieldUname: {
      margin: theme.spacing(1),
      marginLeft: 0,
      paddingRight: 20,
      marginTop: -16
    }
});

class UserCreate extends Component {
    constructor(props) {
        super(props);

        let pLastName = '';
        let pFirstName = '';
        let pEmail = '';
        let pPhone = '';
        let pAddress1 = '';
        let pAddress2 = '';
        let pCity = '';
        let pState = '';
        let pCountry = '';
        let pPostalCode = '';

        let paramPropString = localStorage.getItem('userCreateParamProps');
        if (paramPropString != null)
        {
          let paramProps = JSON.parse(paramPropString);
          pLastName = (paramProps.contactLastName ? paramProps.contactLastName : '');
          pFirstName = (paramProps.contactFirstName ? paramProps.contactFirstName : '');
          pEmail = (paramProps.contactEmail ? paramProps.contactEmail : '');
          pPhone = (paramProps.contactPhone ? paramProps.contactPhone : '');
          pAddress1 = paramProps.address1;
          pAddress2 = paramProps.address2;
          pCity = paramProps.city;
          pState = paramProps.state;
          pCountry = paramProps.country;
          pPostalCode = paramProps.postalCode;
          localStorage.removeItem('userCreateParamProps');
        }


        this.state = {
            showSpinner: false,
            saveStatus: null,
            saveMessage: null,
            saveSnackbarOpen: false,
            saveSnackbarDuration: null,
            userName: '',
            userRole: 1,
            lastName: pLastName,
            firstName: pFirstName,
            email: pEmail,
            phone: pPhone,
            address1: pAddress1,
            address2: pAddress2,
            city: pCity,
            state: pState,
            country: pCountry,
            postalCode: pPostalCode,
            abUserId: null,
            auth0Uid: null,
            accountRole: null,
            emailDialogOpen: false,
            unattachedAppString: null,
            customerAppId: null,
            accountId: null
        }
    }

    componentDidMount() {
      this.unattachedBindCardFetch();

      const params = new URLSearchParams(this.props.location.search);
      let theCustomerAppId = params.get('customerAppId');
      if (theCustomerAppId) {
        this.setState({ customerAppId: theCustomerAppId });
      }

      let theAccountId = params.get('accountId');
      if (theAccountId) {
        this.setState({ accountId: theAccountId });
      }
    }

    /*
    * See if the account has any unattached bind cards.  This is used to put together an app list for invite email.
    * This knowledge might be used to invite a customer as last part of subscription flow.
    */
    unattachedBindCardFetch = () => {

      const { logError } = this.props.auth;

      const params = new URLSearchParams(this.props.location.search);
      let acctId = null;
      let acctIdFromParms = params.get('accountId');
      if (acctIdFromParms !== null) {
        acctId = acctIdFromParms;
      } 

      //console.log(acctId);
      if (acctId) {
        BindCardUnattachedFetch.fetch(acctId).toPromise()
        .then(bcuf => {
           //if there are any nodes, grab the app name and stuff into a grammatically correct string
           if (bcuf.getbindcardsunattached && bcuf.getbindcardsunattached.nodes) {
            let appNames = [];
            var i = 0;
            for (i = 0; i < bcuf.getbindcardsunattached.nodes.length; i++) {
  
              if (appNames.indexOf(bcuf.getbindcardsunattached.nodes[i].appName) === -1) {
                appNames.push(bcuf.getbindcardsunattached.nodes[i].appName);
              }
  
            }
            let appNameString = '';
            for (i = 0; i < appNames.length; i++) {
  
              if (i === 0) {
                appNameString = appNames[i];
              } else {
                if (i === (appNames.length - 1)) {
                  appNameString = appNameString + ' and ' + appNames[i];
                } else {
                  appNameString = appNameString + ', ' + appNames[i];
                }
              }
  
            }
            this.setState({unattachedAppString: appNameString});
           }
  
        })
        .catch(err => {
          //only thing to cause this is perhaps outdated DB structure.
          logError('Exception in UserCreate.js: ' + err);
        })
   
      }
   }

    goBack() {
      this.props.history.goBack();
    }
    
    showSpinner() {
        return this.state.showSpinner;
    }

    setCountry    = (country)    => { this.setState({country:    country}); }  
    setRegion     = (region)     => { this.setState({state:      region}); }  
    setCity       = (city)       => { this.setState({city:       city}); }  
    setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
    setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
    setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

    setAdminCheckbox = () => {
      if (this.state.userRole === 1) {
        this.setState({userRole: 0});
      } else {
        this.setState({userRole: 1});
      }
       
    };

    handleEmailClose = () => {
      this.setState({emailDialogOpen: false});

      if (this.state.customerAppId) {
        // this.props.history.replace('/subscription?customerAppId=' + this.state.customerAppId);       
        var subscriptionReturn = localStorage.getItem('subscriptionReturn');
        if (subscriptionReturn) {
          var subscriptionLink = '/subscription?customerAppId=' + subscriptionReturn + '&hideback=true';
          localStorage.removeItem('subscriptionReturn');
          this.props.history.replace(subscriptionLink);
        } else if (this.state.accountId) {
          localStorage.setItem('customerTabVal', 3);  //positions user on subscriptions tab
          this.props.history.replace('/customer?accountId=' + this.state.accountId);
        } else {
          this.props.history.replace('/subscription?customerAppId=' + this.state.customerAppId);
        }
      } else {
        this.goBack();  //Here they should not go back to create another user.
      }

    };


    render() {
        const { validateEmail, isAuthenticated, isAuthenticatedReseller, isAuthenticatedCustomer, isAuthenticatedVendor, isAuthenticatedAppBind, needAssent } = this.props.auth;
        const classes = this.props.classes;

        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedAppBind() || isAuthenticatedReseller() || isAuthenticatedVendor() || isAuthenticatedCustomer()) {
          const params = new URLSearchParams(this.props.location.search);

          let hideBackParm = params.get('hb'); 

          let acctId = null;
          let acctIdFromParms = params.get('accountId');
          if (acctIdFromParms !== null)
            acctId = acctIdFromParms;
          else
            acctId = abEnvironment.getUserAttribute('a_id');

          /*let address = {
            country:    this.state.country,
            state:      this.state.state,
            city:       this.state.city,
            postalCode: this.state.postalCode,
            address1:   this.state.address1,
            address2:   this.state.address2
          };
          let regionLabel = "Region";*/

          let isAdmin = false;
          if (abEnvironment.getUserAttribute('u_userRole') === '0') {
            isAdmin = true;
          }

          let emailError = false;
          if (this.state.email != null && this.state.email !== '') {
            let emailOk = validateEmail(this.state.email);
            if (! emailOk) {
              emailError = true;
            }
          }                  
          
          return (
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={UserCreateQuery}
              variables={{accountId: acctId}}
              render={({error, props})=> {
                if (error) {
                  return <div>{error.message}</div>
                } else if (props) {
                  let accountType = props.accountTByAccountId.accountType;
                  let accountName = props.accountTByAccountId.accountName;
                  let useBudgets = props.accountTByAccountId.useBudgets;

                  // Determine where the user should be navigated
                  // when done or cancelling.
                  // - If there is an account id in the parameters,
                  //   this is a reseller adding a user customer
                  //   or appbind adding a reseller customer
                  let theLinkText = null;
                  if (acctIdFromParms !== null)
                  {
                    if (accountType === 3)
                    {
                      theLinkText = accountName;
                    }
                    else if (accountType === 4)
                    {
                      theLinkText = accountName;
                    }
                  }
                  else
                  {
                    theLinkText = "Settings";
                  }

                  var subscriptionReturn = localStorage.getItem('subscriptionReturn');
                  if (subscriptionReturn) {
                    theLinkText = "Subscription";
                  }

                  let thePageTitle = "Invite user for " + accountName;

                  const emailSubject = 'Invitation from ' + abEnvironment.getUserAttribute('a_accountName');
                  let emailTextBody = '';
                  if (this.state.unattachedAppString === null || this.state.unattachedAppString === '') {
                    emailTextBody = this.state.firstName + `,\n\nWe'd like to purchase and manage subscriptions for your project.\n\nPlease use our client portal to securely link your credit card, debit card, or bank account. Then we can automatically and transparently expense subscriptions to you.\n\n- ` + abEnvironment.getUserAttribute('a_accountName');
                  } else {
                    emailTextBody = this.state.firstName + `,\n\nWe'd like to purchase and manage subscriptions to ` + this.state.unattachedAppString + ` for your project.\n\nPlease use our client portal to securely link your credit card, debit card, or bank account. Then we can automatically and transparently expense subscriptions to you.\n\n- ` + abEnvironment.getUserAttribute('a_accountName');

                  }
             
                  return (
                    <Grid container spacing={3} direction="row" justifyContent="flex-start">
                      <Grid item xs={12}>
                        {!hideBackParm &&
                        <PageTitle title={thePageTitle} showBackButton={true} name={theLinkText} noMargin={true} history={this.props.history}/>}
                        {hideBackParm &&
                        <PageTitle title={thePageTitle} noMargin={true} history={this.props.history}/>}
                      </Grid>
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" justifyContent="space-around">
                            <Grid item xs={12}>
                              <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
                                User information
                              </Typography>
                            </Grid>
                            {/*
                            <Grid item xs={12} sm={12}>
                              <TextField
                                id="user-name" label="User Name" className={classes.textFieldUname}
                                value={this.state.userName}
                                onChange={(e) => this.setState({ userName: e.target.value })} />
                            </Grid>
                            */}
                            <Grid item xs={12} sm={6}>
                              <TextField data-recording-ignore="mask"
                                id="first-name" label="First name" 
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                inputProps={{ maxLength: 32 }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField data-recording-ignore="mask"
                                id="last-name" label="Last name"
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                inputProps={{ maxLength: 32 }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField data-recording-ignore="mask"
                                id="email" label="Email" 
                                error={emailError}
                                value={this.state.email}
                                onChange={(e) => this.setState({ email: e.target.value })}
                                inputProps={{ maxLength: 254 }}
                              />
                            </Grid>
                            {isAdmin && accountType !== 4 &&
                            <Grid item xs={12} sm={6}>
                              <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={(this.state.userRole === 0)}
                                      onChange={() => {this.setAdminCheckbox()} }
                                      color="primary"
                                    />
                                  }
                                  label="Can administer users"
                                />
                            </Grid>
                            }
                            <Grid item xs={12} sm={6}>
                              {/* remove this grid item when we bring phone back */}
                            </Grid>
                            {/*<Grid item xs={12} sm={6}>
                              <TextField data-recording-ignore="mask"
                                id="phone" label="Phone"
                                value={ this.state.phone }
                                onChange={ (e) => this.setState({ phone: e.target.value }) }
                                InputProps={{
                                  inputComponent: PhoneNumberFormat,
                                }}
                              />
                              </Grid>*/}
                            {/*<Grid item xs={12}>
                              <Typography variant="h6"  style={AppBindStyles.sectionTitle}>
                                Mailing address
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Address
                                address={address}
                                regionLabel={regionLabel}
                                setCountryCodeState={this.setCountry}
                                setRegionCodeState={this.setRegion}
                                setCityState={this.setCity}
                                setPostalCodeState={this.setPostalCode}
                                setAddress1State={this.setAddress1}
                                setAddress2State={this.setAddress2}
                              />
                            </Grid>*/}
                            <Grid item xs={12}>
                              <SaveButton
                                snackbarOpen={this.state.saveSnackbarOpen}
                                autoHideDuration={this.state.saveSnackbarDuration}
                                label="Save and Invite"
                                status={this.state.saveStatus} 
                                message={this.state.saveMessage}
                                disabled={this.disableUserSave()}
                                onSaveClick={() => { this._createUser(acctId, accountType, useBudgets); }}
                                onSnackbarClose={() => { this._onSnackbarClose(); }}
                              />
                              {/*
                              {  !this.showSpinner() && this.state.postalCode && this.state.email &&
                              <Button variant="contained" color="secondary" className={classes.button} onClick={() => {this._createUser(acctId, accountType)}}>
                                Save
                              </Button>
                              }
                              {  !this.showSpinner() && ! (this.state.postalCode && this.state.email) &&
                              <Button variant="contained" className={classes.button}>
                                Save
                              </Button>
                              }
                              {this.showSpinner() &&
                              <Button color="secondary" variant="contained" >
                                <SavingSpinner/></Button>
                              }
                              */}
                            </Grid>
                          </Grid>
                        </Paper>

                        <EmailDialog
                          title="Customize your email"
                          open={this.state.emailDialogOpen}
                          onClose={this.handleEmailClose} >

                          <UserEmailForm
                            auth={this.props.auth}
                            emailTo={this.state.email}
                            testEmailTo={abEnvironment.getUserAttribute('a_email')}
                            emailSubject={emailSubject}
                            emailTextBody={emailTextBody}
                            userId={this.state.abUserId}
                            auth0Uid={this.state.auth0Uid}
                            pAccountId={abEnvironment.getUserAttribute('a_id')}
                            accountId={acctId}
                            userArole={this.state.accountRole} 
                            onClose={this.handleEmailClose}>
                          </UserEmailForm>
                        </EmailDialog>
                      </Grid>
                    </Grid>
                  )
                }
                return <LoadingSpinner />
              }}
            />
          );
        } else {
          return (
            <Redirect to='/home' />
          );
        }
    }

    disableUserSave() {
      const { validateEmail } = this.props.auth;

      if (!this.state.email || !this.state.lastName || !this.state.firstName)
        return true;
      
      // Is email an email address?
      let emailOk = validateEmail(this.state.email);
      if (! emailOk)
        return true;
  
      return false;
    }

    _onSnackbarClose() {
      this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
    }

    _createUser = (accountId, accountType, useBudgets) => {
      this.setState({ saveStatus: 'saving' });
      const { userRole,
              lastName, firstName, email, phone,
              address1, address2, city, state, country, postalCode } = this.state;
      const { callPartnerApi } = this.props.auth;

      let pAccountId = abEnvironment.getUserAttribute('a_id');
      let aPjwt = abEnvironment.getPjwt();
      let success = false;


      callPartnerApi('appbind/user',
                     'POST',
                     {
                      'pjwt':aPjwt,
                      'accountId': accountId,
                      'pAccountId': pAccountId,
                      'accountType': accountType,
                      'userRole': userRole,
                      'lastName': lastName,
                      'firstName': firstName,
                      'email': email,
                      'phone': phone,
                      'address1': address1,
                      'address2': address2,
                      'city': city,
                      'state': state,
                      'country': country,
                      'postalCode': postalCode
                     })
      .then((response) => {
        if (response.status === 200) {
          success = true;
        }
        return response.json();
        /*response.json().then(data => {
          // do something with your data
          console.log(data);
         let errorObj = {
          'error': { errMessage : data.errMessage }
          }
         throw(errorObj);
        });*/
        
      
        
      })
      .then((response) => {
        //console.log(JSON.stringify(response));
        if (success) {
          if (response.accountRole === 'appbind_customer_unauth') {
            //only customer invites get the special email flow.
            this.setState({ saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'User created.', saveSnackbarDuration: 3000, 
            emailDialogOpen: true, abUserId: response.abUserId, auth0Uid: response.auth0Uid, accountRole: response.accountRole});  
          } else {
            this.setState({ saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'User created.', saveSnackbarDuration: 3000});
            this.goBack();
          }
  
        } else {
          //sort of a hack to have this here.
          let theMessage = 'Unable to create user'
          if (response.errMessage != null)
          {
            theMessage = response.errMessage;
          }
          this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });
        }
      })
      .catch(error => {
        let theMessage = 'Unable to create user'
        if (error.errMessage != null)
        {
          theMessage = error.errMessage;
        }
        this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });
      });
    }
}

UserCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(UserCreate);